import { useModuleBEM } from "@b2bportal/core-themes";
import type { Product } from "@b2bportal/purchase-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { RewardsSection } from "../RewardsSection";
import { RewardsSelectionCard } from "../RewardsSelectionCard";
import { useRewardsSelection } from "./hooks";
import styles from "./styles.module.scss";

export const RewardsSelection = ({ product }: { product?: Product }) => {
  const { t } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "RewardsSelection");

  const {
    context: { rewardsSelected, isRewardsDisabled },
    handlers: { onApplyPointsClick, onDoNotApplyPointsClick },
  } = useRewardsSelection(product);

  return (
    <div className={block}>
      <span className={cn("title")}>{t("rewards.title")}</span>

      <RewardsSection
        onClick={onApplyPointsClick}
        disabled={isRewardsDisabled}
      />

      {/* Don't apply points card */}
      <RewardsSelectionCard
        disabled={isRewardsDisabled}
        selected={!rewardsSelected}
        onClick={onDoNotApplyPointsClick}
        footnote={undefined}
      >
        <span>{t("rewards.card.doNotApplyPointsTitle")}</span>
      </RewardsSelectionCard>
    </div>
  );
};
